import type { ReactNode } from "react";
import { isEmpty } from "lodash";
import { isOrgDesignBetaEnabled } from "src/components/OrgChart/controller/dnd/featureFlags";

export type MaybeBool = boolean | null | undefined;

export const isWorkforceHidden = (
  isRestricted: MaybeBool,
  showWorkforce: MaybeBool
): boolean => !!isRestricted || !showWorkforce;

export const isTeamCanvasHidden = (params: {
  enableOrgDesign: MaybeBool;
  enableDemoODOptions: MaybeBool;
  enableTeamCanvas: MaybeBool;
  isRestricted: MaybeBool;
}): boolean =>
  !isOrgDesignBetaEnabled({
    enableOrgDesign: params.enableOrgDesign,
    enableDemoODOptions: params.enableDemoODOptions,
  }) ||
  !params.enableTeamCanvas ||
  !!params.isRestricted;

export const isPointInTimeHidden = (
  isTeamAllocationsPage: MaybeBool,
  isRestricted: MaybeBool
): boolean => !!isTeamAllocationsPage || !!isRestricted;

export const getPointInTimeBadge = (dateSettings: unknown): ReactNode =>
  isEmpty(dateSettings) ? null : "!";

export const isPageSpecificFilterHidden = (
  isTargetPage: MaybeBool,
  isRestricted: MaybeBool
): boolean => !isTargetPage || !!isRestricted;

export const getFilterBadgeProps = (
  activeFilterCount: number
): { badgeNumber?: number } =>
  activeFilterCount !== 0 ? { badgeNumber: activeFilterCount } : {};

export const getToggleFteBadge = (fteMode: MaybeBool): ReactNode =>
  fteMode ? "!" : null;

export const isGuidedTourHidden = (params: {
  isSummaryPage: MaybeBool;
  tourName: string | null | undefined;
  tourAvailable: MaybeBool;
  isRestricted: MaybeBool;
}): boolean =>
  !!params.isSummaryPage ||
  !(params.tourName && params.tourAvailable) ||
  !!params.isRestricted;
